
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, IPurchaseOrderLookup, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * PurchaseOrderLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PurchaseOrderLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<IPurchaseOrderLookup[]>> {
        return this.$apiService.sendAuth("IPurchaseOrderLookupService/Lookup", pCriteria);
    }
}
